import { Image, Modal, Tag } from 'antd';
import { Label } from 'common/ui/label';
import { cn } from 'utils/cn';
import {
  investmentIdentificationImageStatusColors,
  investmentIdentificationImageStatusLabel,
  investmentIdentificationImageTypeLabels,
} from 'utils/constants';
import IndividualIdentificationDetail from './individual-identification-detail';
import { AutoKycResponse } from './types';

interface IdentificationPreviewModalProps {
  open: boolean;
  onClose: () => void;
  identification: any;
  autoKyc: AutoKycResponse;
  selectedImage: any | null; // Single selected image
}

const IdentificationPreviewModal = ({
  open,
  onClose,
  identification,
  autoKyc,
  selectedImage,
}: IdentificationPreviewModalProps) => {
  if (!selectedImage) return null;

  const imageBase64 = `data:image/jpeg;base64,${selectedImage.data}`;
  const previewSrc = selectedImage.image_url || imageBase64;
  const isSelfie = selectedImage.image_type === 'selfie';

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="96%"
      style={{ top: 9 }}
      destroyOnClose
    >
      <div
        className={cn('max-h-[89vh] py-4', isSelfie ? 'overflow-y-auto' : '')}
      >
        <div className="flex lg:flex-row flex-col-reverse gap-2 relative">
          {/* Individual Identification Detail */}
          <div
            className={cn(
              'lg:w-2/5 space-y-2',
              isSelfie ? '' : 'overflow-y-auto lg:h-fit h-[45vh]'
            )}
          >
            <IndividualIdentificationDetail
              userIdentification={identification}
              autoKyc={autoKyc}
              showLinks={false}
            />
          </div>

          {/* Selected Image */}
          <div className="lg:w-3/5 space-y-2 ">
            <div className="relative w-full flex items-center justify-between gap-2">
              <Label>
                {investmentIdentificationImageTypeLabels[
                  selectedImage.image_type
                ] || selectedImage.image_type}
              </Label>
              <Tag
                color={
                  investmentIdentificationImageStatusColors[
                    selectedImage.status
                  ]
                }
              >
                {investmentIdentificationImageStatusLabel[
                  selectedImage.status
                ] || selectedImage.status}
              </Tag>
            </div>
            <div className="relative h-96 bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center">
              <Image
                style={{ objectFit: 'contain' }}
                width="100%"
                height="100%"
                src={previewSrc}
              />
              {selectedImage.error_message && (
                <div className="absolute bottom-0 right-0 px-3 py-2 bg-black/50 backdrop-blur-sm z-10">
                  <Tag color="purple">{selectedImage.error_message}</Tag>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default IdentificationPreviewModal;
